import type RealtimeKitClient from "@cloudflare/realtimekit";

/**
 * No mobile, iOS/Android tendem a rotear WebRTC para o auricular quando o
 * player de vídeo/áudio está com display:none (aba Cenário). setupSpeaker()
 * do RTK reaplica a saída preferida (alto-falante quando disponível).
 */
export async function ensureMobileSpeakerOutput(
    meetingClient: RealtimeKitClient | null,
): Promise<void> {
    if (!meetingClient) {
        return;
    }

    const self = meetingClient.self as RealtimeKitClient["self"] & {
        setupSpeaker?: () => Promise<void>;
        getSpeakerDevices?: () => Promise<MediaDeviceInfo[]>;
        setSpeakerDevice?: (
            device: MediaDeviceInfo,
            opts: { saveDevicePreference: boolean },
        ) => Promise<void>;
    };

    try {
        if (typeof self.setupSpeaker === "function") {
            await self.setupSpeaker();
            return;
        }
    } catch {
        // continua com fallback abaixo
    }

    try {
        if (typeof self.getSpeakerDevices !== "function") {
            return;
        }
        const speakers = await self.getSpeakerDevices();
        const preferred =
            speakers.find((d) => /speaker|alto|loud|default/i.test(d.label)) ??
            speakers[0];
        if (preferred && typeof self.setSpeakerDevice === "function") {
            await self.setSpeakerDevice(preferred, { saveDevicePreference: false });
        }
    } catch {
        // best-effort — nunca quebra a sala
    }
}
